import { useEffect } from 'react';
import {
  CenterButtonContainer,
  TextBold,
  TextRegular,
} from '../../../styles/GlobalStyledComponents';
import UnknowError from '../../../assets/images/Errors/unknownError.svg';
import Button from '../../../components/Button/Button';
import { colors } from '../../../styles/Colors';
import {
  ImgWrapper,
  ModalImgDiv,
  ModalTextWrapper,
  ModalWrapper,
} from '../FinalModalStyledComponents';
import { PhonesEnum } from '../../../interfaces/Phones';
import GAnalyticsService from '../../../services/GAnalytics/ganalytics.service';


const CoClientError = () => {
  const { red4, white } = colors;

  // Se lanza la llamada al número CO de soporte porque esta pantalla solo es para CO
  const handleCall = () => {
    GAnalyticsService.sendContactUsEvent();
    window.location.href = `tel:+34${PhonesEnum.SUPPORT_PHONE_CO}`;
  };

  useEffect(() => {
    GAnalyticsService.sendAccessDeniedEvent();
  }, []);

  return (
    <ModalWrapper id="unknown-error-page">
      <ModalTextWrapper id="unknown-error-title-wrapper">
        <TextBold
          fontSize={24}
          lineHeight={32}
          align="center"
          id="unknown-error-title"
        >
          ¡Ups!
        </TextBold>
      </ModalTextWrapper>
      <ModalTextWrapper id="unknown-error-text-wrapper">
          <TextRegular
            fontSize={18}
            lineHeight={24}
            id="unknown-error-text"
            color="gray6"
          >
            Hemos detectado un grave problema con tus pagos.
          </TextRegular>
      </ModalTextWrapper>
      <ModalTextWrapper id="unknown-error-text-wrapper-2">
          <TextRegular
            fontSize={18}
            lineHeight={24}
            id="unknown-error-text-2"
            color="gray6"
          >
            Ponte en contacto con nosotros lo antes posible para poder solucionarlo.
          </TextRegular>
      </ModalTextWrapper>
      <ImgWrapper id="unknown-error-img-wrapper">
        <ModalImgDiv
          src={UnknowError}
          id="unknown-error-img"
          alt="unknown-error image"
          title="unknown-error image"
          width={''}
          height={''}
        />
      </ImgWrapper>
      <CenterButtonContainer>
        <Button
          color={white}
          backgroundColor={red4}
          minWidth="280px"
          click={handleCall}
          id="unknown-error-back-btn"
        >
          <TextBold fontSize={16} color={white} lineHeight={20}>
            Llámanos
          </TextBold>
        </Button>
      </CenterButtonContainer>
    </ModalWrapper>
  );
};

export default CoClientError;
